/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RemoveDashboardWidgetRequestBody = {
  /**
   * The dashboard the card is on
   */
  id: string;
  /**
   * The card to remove
   */
  placementId: string;
};

/** @internal */
export type RemoveDashboardWidgetRequestBody$Outbound = {
  id: string;
  placement_id: string;
};

/** @internal */
export const RemoveDashboardWidgetRequestBody$outboundSchema: z.ZodMiniType<
  RemoveDashboardWidgetRequestBody$Outbound,
  RemoveDashboardWidgetRequestBody
> = z.pipe(
  z.object({
    id: z.string(),
    placementId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      placementId: "placement_id",
    });
  }),
);

export function removeDashboardWidgetRequestBodyToJSON(
  removeDashboardWidgetRequestBody: RemoveDashboardWidgetRequestBody,
): string {
  return JSON.stringify(
    RemoveDashboardWidgetRequestBody$outboundSchema.parse(
      removeDashboardWidgetRequestBody,
    ),
  );
}
